export var cibSnapcraft = ["32 32", "<path d='M18.406 17.823v-10.234l7.057 3.146zM4.932 31.354l8.656-16.297 3.797 3.792zM0 0.646l17.807 6.469v11.307zM29.073 7.115h-10.26l13.188 5.88z'/>"];
